module.exports = function(app) {
    app.directive('transactionDetailDrawer', ['sessionData', function(sessionData) {
        return {
            restrict: 'A',
            //template: require('directives/spending/accountDrawer.html'),
            templateUrl: 'spending.appTemplate.html/chmhom/directives/spending/transactionDetailDrawer',
            scope: {
                transaction: '=transactionDetailDrawer'

            },
            link: function(scope){

            },
            controller: ['sessionData', '$scope', '$state', 'services',  'modal', 'storage', '$timeout',  '$q', 'coremetrics', 'session', 'brand','$location','spaUtil','$window',
                function(sessionData, $scope, $state, services, modal, storage, $timeout,  $q, coremetrics, session, brand,$location,spaUtil,$window) {
                    var transaction = $scope.transaction;


                }
            ]
        };
    }]);


};